var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTraining({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 2H2V24H13C13.5523 24 14 24.4477 14 25C14 25.5523 13.5523 26 13 26H6V31C6 31.5523 5.55228 32 5 32C4.44772 32 4 31.5523 4 31V26H0V0H32V25C32 25.5523 31.5523 26 31 26C30.4477 26 30 25.5523 30 25V2Z",
    fill: "#FF552E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9296 19H16.6056C16.2107 19 15.8247 18.8831 15.4962 18.6641L13 17L11.2511 12.6277C11.0994 12.2486 10.7322 12 10.3239 12C9.66044 12 9.18144 12.635 9.3637 13.273L10.8247 18.3864C10.9387 18.7855 11.1742 19.1393 11.4983 19.3987L15.6766 22.7412C15.8837 22.9069 16.0165 23.1481 16.0457 23.4117L16.9012 31.1104C16.9574 31.6169 17.3855 32 17.895 32H23C23.5523 32 24 31.5523 24 31V23.5L26 26L26.8607 31.1645C26.9411 31.6466 27.3583 32 27.8471 32C28.4556 32 28.923 31.461 28.837 30.8587L28.0642 25.4491C28.0219 25.1535 27.914 24.871 27.7484 24.6225L24.5937 19.8906C24.2228 19.3342 23.5983 19 22.9296 19Z",
    fill: "#FF552E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15C23 16.6569 21.6569 18 20 18C18.3431 18 17 16.6569 17 15C17 13.3431 18.3431 12 20 12C21.6569 12 23 13.3431 23 15Z",
    fill: "#FF552E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H5Z",
    fill: "#FF552E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4 8.44771 4.44772 8 5 8H15C15.5523 8 16 8.44771 16 9C16 9.55228 15.5523 10 15 10H5C4.44771 10 4 9.55228 4 9Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon-training.69329c471144e599676f80d93fd55e5b.svg";
export { ForwardRef as ReactComponent };